
// this should be kept in sync with ShareToolType.java
export const SHARE_TOOLS = {
    FACEBOOK: 'FACEBOOK',
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER',
    INSTAGRAM: 'INSTAGRAM',
    EMAIL: 'EMAIL',
    SMS: 'SMS',
    DIRECT_LINK: 'DIRECT_LINK',
    MOBILE_SHARE_TRAY: 'MOBILE_SHARE_TRAY',
    NEXTDOOR: 'NEXTDOOR',
};

export const trackShareToolClick = function (projectId, shareTool) {
    if (!projectId) {
        return;
    }

    var data = {
        projectId: projectId,
        shareTool: shareTool,
    };

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: secureBaseURL + 'teacher/track-sharetool-usage.html',
        data: data,
        // withCredentials is necessary to pass cookies since this is sometimes a cross-origin request
        xhrFields: { withCredentials: true },
    });
};
